import { render, staticRenderFns } from "./PullQuote.vue?vue&type=template&id=0a74c6f0&"
import script from "./PullQuote.vue?vue&type=script&lang=js&"
export * from "./PullQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports